import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import axios from 'axios';

const SiteContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_name: 'Ofertopolis',
    logo_url: 'https://images.unsplash.com/photo-1617259111909-a776d5969b17?w=120&h=120&fit=crop',
    whatsapp_link: 'https://whatsapp.com/channel/0029VasRUkz3AzNOvVJavK1J',
    facebook_link: 'https://www.facebook.com/share/g/1HtdhrYGnu/'
  });
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
    if (localStorage.getItem('darkMode') === null && settings.dark_mode_default) {
      setDarkMode(true);
    }
  }, [settings.dark_mode_default]);

  const toggleDarkMode = () => {
    setDarkMode(prev => {
      localStorage.setItem('darkMode', String(!prev));
      return !prev;
    });
  };

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = (newSettings) => {
    setSettings(newSettings);
  };

  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    if (url.startsWith('data:')) return url;
    // Handle both old /uploads/ and new /api/uploads/ paths
    if (url.startsWith('/uploads/')) {
      return `${process.env.REACT_APP_BACKEND_URL}/api${url}`;
    }
    if (url.startsWith('/api/uploads/')) {
      return `${process.env.REACT_APP_BACKEND_URL}${url}`;
    }
    return url;
  };

  return (
    <SiteContext.Provider value={useMemo(() => ({ settings, loading, updateSettings, fetchSettings, getImageUrl, darkMode, toggleDarkMode }), [settings, loading, darkMode])}>
      {loading ? (
        <div
          className="min-h-screen w-full flex items-center justify-center"
          style={{ backgroundColor: darkMode ? '#0f172a' : '#FFD600' }}
          data-testid="site-loading-splash"
        >
          <div className="w-10 h-10 border-4 border-black/20 border-t-black rounded-full animate-spin" />
        </div>
      ) : (
        children
      )}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
};
